// Third-party libraries
import React, { useEffect } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

import formatting from "../../../utils/formatHelpers";
import { Mobile, Default } from "../../../utils/deviceHelpers";

export default function RefiningEstimatorPreview(props) {
  const { refiningQuotes, setRefiningQuotes } = props;
  const handleRemove = (indexToRemove) => {
    setRefiningQuotes((prevQuotes) =>
      prevQuotes.filter((_, index) => index !== indexToRemove)
    );
  };

  useEffect(() => {}, [refiningQuotes]);
  return (
    <>
      <Typography variant="h6" align="center">
        Your Estimates
      </Typography>
      <Table size="small">
        <TableHead>
          <TableRow>
            <Mobile>
              <TableCell>Metal (Wt)</TableCell>
            </Mobile>
            <Default>
              <TableCell>Weight</TableCell>
              <TableCell>Metal</TableCell>
            </Default>
            <TableCell>We'll Pay</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {refiningQuotes.map((estimate, index) => (
            <TableRow key={index}>
              <Mobile>
                <TableCell>
                  <Typography>
                    {estimate.lot_code} ({estimate.weight})
                  </Typography>
                </TableCell>
              </Mobile>
              <Default>
                <TableCell>
                  <Typography>
                    {estimate.weight} {estimate.weight_unit.toUpperCase()}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography>{estimate.lot_code}</Typography>
                </TableCell>
              </Default>
              <TableCell>
                <Typography>{formatting["price2"](estimate.price)}</Typography>
              </TableCell>
              <TableCell>
                <ClearIcon
                  onClick={() => handleRemove(index)}
                  className="pointer"
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
}
